export const toLocalMonthDate = (dateStr: string): string => {
  const date = new Date(dateStr)
  return new Intl.DateTimeFormat(undefined, {
    month: 'long',
    day: 'numeric',
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  }).format(date)
}

export const toLocalYearMonthDate = (value: string | Date): string => {
  const date = typeof value === 'string' ? new Date(value) : value
  return new Intl.DateTimeFormat(undefined, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  }).format(date)
}
